/**
 * How long a toast that offers Undo stays on screen, in milliseconds. The
 * Toaster's 4s default suits a message you only read; Undo asks for a
 * decision and a click, after the reader has noticed what just went, which
 * 4s rarely leaves time for. Hover, focus and a hidden tab still pause the
 * timer.
 */
export const UNDO_TOAST_DURATION_MS = 8000;
